import { render, staticRenderFns } from "./signList.vue?vue&type=template&id=0c624105&"
import script from "./signList.vue?vue&type=script&lang=js&"
export * from "./signList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports